import { render } from "./Menu.html?vue&type=template&id=f0b2f31c&scoped=true&ts=true"
import script from "./Menu.ts?vue&type=script&lang=ts"
export * from "./Menu.ts?vue&type=script&lang=ts"

import "./Menu.css?vue&type=style&index=0&id=f0b2f31c&scoped=true&lang=css"

import exportComponent from "E:\\yl\\web\\lvxingshibie-backend\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b2f31c"]])

export default __exports__